import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import $ from "jquery";
import feather from "feather-icons";
import {logoutUser} from '../../request/auth';
import PerfectScrollbar from 'perfect-scrollbar';
import {useDispatch, useSelector} from "react-redux";

const Header = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth.user);
    const [statistics, set_statistics] = useState("nav-item");
    const [agent, set_agent] = useState("nav-item");
    const [access_control, set_access_control] = useState("nav-item");
    const [push_notification, set_push_notification] = useState("nav-item");
    const [country, set_country] = useState("nav-item");
    const [property, set_property] = useState("nav-item");

    const onLogoutClick = (event) => {
        event.preventDefault();
        dispatch(logoutUser());
    };

    const handleActiveLink = (data) => {
        set_statistics("nav-item");
        set_agent("nav-item");
        set_property("nav-item");
        set_access_control("nav-item");
        set_country("nav-item");
        set_push_notification("nav-item");
        switch (data) {
            case "dashboard":
                set_statistics("nav-item active");
                break;
            case "agent":
                set_agent("nav-item active");
                break;
            case "property":
                set_property("nav-item active");
                break;
            case "country":
                set_country("nav-item active");
                break;
            case "push_notification":
                set_push_notification("nav-item active");
                break;
            case "access_control":
                set_access_control("nav-item active");
                break;
            default:
                set_statistics("nav-item");
                break;
        }
    };

    useEffect(() => {

        handleActiveLink("default");

        $(function () {
            'use strict';
            feather.replace();

            const asideBody = new PerfectScrollbar('.aside-body', {
                suppressScrollX: true
            });

            if($('.aside-backdrop').length === 0) {
                $('body').append('<div class="aside-backdrop"></div>');
            }

            var mql = window.matchMedia('(min-width:992px) and (max-width: 1199px)');

            function doMinimize(e) {
                if (e.matches) {
                    $('.aside').addClass('minimize');
                } else {
                    $('.aside').removeClass('minimize');
                }

                asideBody.update()
            }

            mql.addListener(doMinimize);
            doMinimize(mql);

            $('.aside-menu-link').on('click', function(e){
                e.preventDefault();

                if(window.matchMedia('(min-width: 992px)').matches) {
                    $(this).closest('.aside').toggleClass('minimize');
                } else {

                    $('body').toggleClass('show-aside');
                }

                asideBody.update()
            });

            $('.nav-aside .with-sub').on('click', '.nav-link', function(e){
                e.preventDefault();

                $(this).parent().siblings().removeClass('show');
                $(this).parent().toggleClass('show');

                asideBody.update()
            });

            $('body').on('mouseenter', '.minimize .aside-body', function(e){
                console.log('e');
                $(this).parent().addClass('maximize');
            });

            $('body').on('mouseleave', '.minimize .aside-body', function(e){
                $(this).parent().removeClass('maximize');

                asideBody.update()
            });

            $('body').on('click', '.aside-backdrop', function(e){
                $('body').removeClass('show-aside');
            })
        });
    }, []);

    return (
        <aside className="aside aside-fixed">
            <div className="aside-header">
                <a href="#" className="aside-logo">Con<span>sole</span></a>
                <a href="#" className="aside-menu-link">
                    <i data-feather="menu"></i>
                    <i data-feather="x"></i>
                </a>
            </div>
            <div className="aside-body">
                <div className="aside-loggedin">
                    <div className="aside-loggedin-user">
                        <a href="#loggedinMenu" className="d-flex align-items-center justify-content-between mg-b-2"
                           data-toggle="collapse">
                            <h6 className="tx-semibold mg-b-0">{auth.user.name}</h6>
                            <i data-feather="chevron-down"></i>
                        </a>
                        <p className="tx-color-03 tx-12 mg-b-0">{auth.user.role}</p>
                    </div>
                    <div className="collapse" id="loggedinMenu">
                        <ul className="nav nav-aside mg-b-0">
                            <li className="nav-item"><Link to="#" onClick={onLogoutClick.bind()} className="nav-link"><i data-feather="log-out"></i>
                                <span>Sign Out</span></Link></li>
                        </ul>
                    </div>
                </div>

                <ul className="nav nav-aside">
                    <li className="nav-label">General</li>
                    <li className={statistics}><Link to="/dashboard" onClick={handleActiveLink.bind(null, "dashboard")} className="nav-link"><i data-feather="users"></i> <span>Users</span></Link></li>
                    <li className={agent}><Link to="/agent" onClick={handleActiveLink.bind(null, "agent")} className="nav-link"><i data-feather="user-plus"></i> <span>Agent</span></Link></li>
                    <li className={property}><Link to="/property" onClick={handleActiveLink.bind(null, "property")} className="nav-link"><i data-feather="home"></i> <span>Property</span></Link></li>

                    <li className="nav-label mg-t-25">Applications</li>
                    <li className={push_notification}><Link to="/push-notification" onClick={handleActiveLink.bind(null, "push_notification")} className="nav-link"><i data-feather="bell"></i> <span>Push Notification</span></Link></li>
                    <li className={access_control}><Link to="/access-control" onClick={handleActiveLink.bind(null, "access_control")} className="nav-link"><i data-feather="users"></i> <span>Access Control</span></Link></li>
                    <li className={country}><Link to="/country" onClick={handleActiveLink.bind(null, "country")} className="nav-link"><i data-feather="globe"></i> <span>Country</span></Link></li>
                </ul>
            </div>
        </aside>
    );
};

export default Header;
